// js/utils/net/request-guard.js
// Centralized guard to prevent stale renders and cancel in-flight requests.

const active = new Map(); // key -> { requestId, controller }

/**
 * Start a new tracked request for a logical "key".
 * - Optionally cancels any prior request for the same key.
 */
export function startNewRequest(key, { cancelPrevious = true } = {}) {
    const controller = new AbortController();
    const requestId = `${Date.now()}_${Math.random().toString(36).slice(2)}`;

    if (cancelPrevious) {
        const prev = active.get(key);
        try { prev?.controller?.abort(); } catch (_) {}
    }

    active.set(key, { requestId, controller });

    return {
        requestId,
        signal: controller.signal,
        /** True if another request has superseded this one. */
        isStale: () => active.get(key)?.requestId !== requestId,
        /** Clear tracking if this request is still the active one. */
        finalize: () => {
            if (active.get(key)?.requestId === requestId) active.delete(key);
        },
        /** Abort this request explicitly. */
        abort: () => controller.abort(),
    };
}
